import { render } from "./FactoryData.vue?vue&type=template&id=4c6a79d8"
import script from "./FactoryData.vue?vue&type=script&lang=js"
export * from "./FactoryData.vue?vue&type=script&lang=js"

import "./FactoryData.vue?vue&type=style&index=0&id=4c6a79d8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__